export const translateErrorMessage = (message?: string): string => {
  if (!message) return 'Ocorreu um erro inesperado, tente novamente.';

  const constraintViolationRegex =
    /Constraint violation error: Incompatibility between the first installment due date and registration date\. Considering the disbursement date, the first installment due date should be from (.*) onwards/i;

  const match = message.match(constraintViolationRegex);
  if (match) {
    const month = match[1];
    const months: Record<string, string> = {
      January: 'janeiro',
      February: 'fevereiro',
      March: 'março',
      April: 'abril',
      May: 'maio',
      June: 'junho',
      July: 'julho',
      August: 'agosto',
      September: 'setembro',
      October: 'outubro',
      November: 'novembro',
      December: 'dezembro',
      january: 'janeiro',
      february: 'fevereiro',
      march: 'março',
      april: 'abril',
      may: 'maio',
      june: 'junho',
      july: 'julho',
      august: 'agosto',
      september: 'setembro',
      october: 'outubro',
      november: 'novembro',
      december: 'dezembro',
    };
    const translatedMonth = months[month] || month;
    return `Incompatibilidade na data de 1º pagamento. Considerando a data de desembolso, o vencimento da primeira parcela deve ser a partir de ${translatedMonth}.`;
  }

  return message;
};
